import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
    padding: 5px 0 5px;
    line-height: 30px;
  `,

  inputWrapper: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,
})

export default useStyles
